import React, { useRef, useState, useEffect, Fragment } from 'react'
import './PreviewNews.scss'
import ProfilePicture from '../ProfilePicture/ProfilePicture'
import { useSelector } from 'react-redux'
import { calculateReadingTime, getFirstParagraphText, getFirstTitleFromHtml } from '../../../helpers/utilities'
import Icon from '../Icon/Icon'

const PreviewNews = ({ content, onUploadMedia, isNotValid, classNames, existingMediaUrl, type="preview" }) => {

    const { user } = useSelector(state => ({
        user: state.auth.user
    }))
    const [previewImage, setPreviewImage] = useState()
    const fileInputRef = useRef(null);

    // Set existing media URL when component mounts or when existingMediaUrl changes
    useEffect(() => {
        if (existingMediaUrl && !previewImage) {
            setPreviewImage(existingMediaUrl);
        }
    }, [existingMediaUrl, previewImage]);

    const handleImageClick = () => {
        if (fileInputRef.current) fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && typeof onUploadMedia === 'function') {
            onUploadMedia(file);
            const previewUrl = URL.createObjectURL(file);
            setPreviewImage(previewUrl)
        }
    };

    const handleDeleteImage = () => {
        onUploadMedia(null)
        setPreviewImage(null)
    } 

    return (
        <div className={`new-card-container mb-24 pr-16 ${classNames}`}>
            <div className='news-header d-flex aic mb-12 mx-16'>
                <ProfilePicture imgUrl={user.profilePicture} no_edit={true} showIcon={false} width={32} height={32} />
                <p className='fs-xs fg-crea fw-medium my-0 ml-8 tt-uppercase'>{`${user.userName || user.firstName}`}</p>
            </div>
            <div className='news-card mr-16'>
                <div className='news-content d-flex'>
                    <div>
                        <p className='fg-black fw-medium-bold mt-0 mb-0 title-news'>{getFirstTitleFromHtml(content) || 'Your News Title'}</p>
                        <p className='fs-real fw-medium fg-grey7 my-0 ml-auto d-flex aic'>{calculateReadingTime(content)} min read <span className='dot'></span> Just now</p>
                        <p className='fs-xs fg-dark my-0 fw-medium content-itself'>{getFirstParagraphText(content) || 'Your news content will appear here...'}</p>
                    </div>
                    <div className={`ml-auto img-news-container ${isNotValid ? 'invalid' : ''}`} style={{ cursor: 'pointer' }} onClick={handleImageClick}>
                        {previewImage ? (
                            <Fragment>
                                <img className='img-news' src={previewImage} alt='preview' width={104} height={104} />
                                <span className="trash-news" onClick={handleDeleteImage}><Icon alias={'trash'} width={24} color='transparent' stroke='#C9100E' className='ml-auto' /></span>
                            </Fragment>
                        ) : (
                            <div className="img-news img-placeholder d-flex f-column aic jcc">
                                <Icon className={'mb-8'} alias='plus' width={20} height={20} color='#999' />
                                <p className='my-0 fs-xxs fg-grey fw-medium'>Thumbnail</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {type !== 'edit' && <div className='news-footer d-flex aic mt-12 mx-16'>
                <span className="d-flex"><Icon alias={"like"} color="#282828" stroke={"#282828"} width={24} /></span>
                <p className="fs-xxs fg-crea fw-medium-bold ml-8 my-0">0</p>
                <span className="d-flex ml-16"><Icon alias={"comment"} stroke="#282828" color='none' width={24} /></span>
                <p className="fs-xxs fg-crea fw-medium-bold ml-8 my-0">0</p>
                <span className="d-flex ml-16">
                    <Icon alias={"star"} strokeWidth={2} color="#282828" width={24} />
                </span>
                <span className="d-flex"><Icon alias={"share"} stroke="#282828" color='none' width={24} className={"ml-24"} /></span>
                <button className="contribute-btn btn-sm btn-xs red-outline-btn d-flex aic ml-auto fs-tiny fw-medium">
                    <Icon alias={"credit_card"} color="#FF3232" stroke={'#FF3232'} width={16} className={'mr-4'} />
                    <span className='fs-tiny fw-extra-bold'>Contribute</span>
                </button>
            </div>}
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileChange}
            />
        </div>
    )
}

export default PreviewNews